export class SegWithIndex {
    // offset
    constructor(pts, i) {
        /*Assert.assert(i < pts.length && i >= 0)*/
        this.Points = pts;
        this.I = i;
    }
    static equal(a, b) {
        return a.I === b.I && a.Points === b.Points;
    }
    get Start() {
        return this.Points[this.I];
    }
    get End() {
        return this.Points[this.I + 1];
    }
}
//# sourceMappingURL=SegWithIndex.js.map